/*
 * @Date: 2022-07-21 14:24:29
 * @Author: manuelzhao
 * @LastEditors: manuelzhao
 * @LastEditTime: 2022-09-15 14:13:19
 * @Description: 请求防抖实现
 * @FilePath: /wemeet-web-shopping/src/hooks/useDebounce.ts
 */
const useDebounce = (services: (...a: any) => Promise<any>): any => {
  let isLoading = false;

  return (...args: any) => {
    if (isLoading) {
      return Promise.resolve(null);
    }
    isLoading = true;

    return services
      .apply(this, args)
      .then((res) => {
        isLoading = false;
        return res;
      })
      .catch((err) => {
        isLoading = false;
        // throw new Error(err);
        return Promise.reject(err);
      });
  };
};

export default useDebounce;
